<template>
  <div id="login-main">
    <div class="login-title">编程课堂</div>
    <form>
      <div class="form-list">
        <img src="@/assets/images/login/phone.png" alt="tal" />
        <label for="tal"></label>
        <el-dropdown class="my-el-dropdown" placement="bottom-start" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link" style="font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #262626;padding-right:10px">
            {{dropdownDefault}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="my-dropdown1">
            <el-dropdown-item class="my-el-dropdown-item"
            v-for="(item,index) in dropdownList" :key="index" :command="item.en">
              <p>{{item.zh}}</p>
              <p>{{item.en}}</p>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <input type="text" id="tal" v-model="tal" placeholder="手机号" style="height:22px;border-left:1px solid #BBBBBB"/>
      </div>
      <div class="form-list">
        <img src="@/assets/images/login/pass.png" alt="pass" />
        <label for="pass"></label>
        <input type="password" id="pass" v-model="pass" placeholder="密码"/>
      </div>
      <router-link tag="p" to="changepasswd" class="forgot-pass">忘记密码?</router-link>
      <p class="error-msg">{{errorMessage}}</p>
      <div class="login-btn" @click="loginHandler">登 录</div>
    </form>
  </div>
</template>

<script>
export default {
  name: "LoginMain",
  components: {
  },
  data () {
    return {
      tal: "",
      pass: "",
      errorMessage: "",
      dropdownDefault: "+86",
      dropdownList: [
        { zh: "中国大陆", en: "+86" },
        { zh: "中国香港", en: "+852" },
        { zh: "中国澳门", en: "+853" },
        { zh: "中国台湾", en: "+886" },
        { zh: "日本", en: "+81" },
        { zh: "韩国", en: "+82" },
        { zh: "美国", en: "+1" },
        { zh: "加拿大", en: "+1" },
        { zh: "英国", en: "+44" },
        { zh: "法国", en: "+33" },
        { zh: "德国", en: "+49" },
        { zh: "俄罗斯", en: "+7" },
        { zh: "西班牙", en: "+34" },
        { zh: "新加坡", en: "+65" },
        { zh: "马来西亚", en: "+60" },
        { zh: "泰国", en: "+66" },
        { zh: "印度", en: "+91" },
        { zh: "澳大利亚", en: "+61" },
        { zh: "新西兰", en: "+64" }
      ]
    }
  },
  methods: {
    handleCommand(command) {
      this.dropdownDefault = command;
    },
    loginHandler () {
      if(this.tal == "" || this.pass == ""){
        this.errorMessage = "用户名和密码不能为空";
        return;
      }
      
      // var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
      // if (!myreg.test(this.tal)) {
      //   this.errorMessage = "手机号填写有误"
      //   return;
      // }
      this.errorMessage = "";

      this.axios.post("/signin.json",{
        // mobile: this.tal.trim(),
        mobile: `${this.dropdownDefault}-${this.tal.trim()}`,
        passwd: this.pass
      }).then((res) => {
        // window.location('/', '_self');
        this.$router.push("/classlist");
      }).catch((error) => {
        if (error.response) {
          let data = error.response.data;
          this.errorMessage = data.error.message;
        } 
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.my-el-dropdown{
  // position: relative;
}
.my-el-dropdown-item{
  display: flex;
  justify-content: space-between;
}
.my-dropdown{
  width: 320px;
  height: 300px;
  overflow: auto;
}
.my-dropdown1{
  width: 320px;
  height: 400px;
  overflow: auto;
}
#login-main{
  width: 414px;
  height: auto;
  position: absolute;
  background: #FFFFFF;  
  box-shadow: 0px 0px 14px 0px rgba(8,164,144,0.5);
  border-radius: 22px;
  top: 105px;
  right: 124px;
  padding: 44px 47px 50px 47px;
  .login-title{   
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #565656;
    text-align: center;
  }
  form{
    margin-top: 37px;
    .form-list{
      width: 320px;
      height: 55px;
      background:rgba(255,255,255,1);
      border: 1px solid #979797;
      border-radius: 27px;
      margin: 23px auto 0px;
      display: flex;
      align-items: center;
      img{
        height: 20px;
        margin: 0px 30px;
        display: inline-block;
      }
      label{
        font-size: 20px;
        position: relative;
        &::before{
          content: "";
          width: 1px;
          height: 22px;
          position: absolute;
          left: -15px;
          top: 50%;
          margin-top: -11px;
          background: #bbbbbb;
        }
      }
      input{
        width: 150px;
        height: 40px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #969393;
        border: none;
        outline: none;
        background: none;
        padding-left: 10px;
        &::placeholder{
           color: #B3B3B3;
        }
      }
    }
    .login-btn{
      color: #fff;
      font-size: 15px;
      width: 100%;
      height: 59px;
      line-height: 59px;
      text-align: center;
      background: linear-gradient(135deg, #FFDC4B 0%, #FDB624 100%);
      border-radius: 34px;
      margin: 30px auto 0px;
      cursor: pointer;  
      font-size: 27px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-shadow: 0px 0px 4px rgba(189, 93, 0, 0.5);
    }
    .error-msg{
      // line-height: 30px;
      font-size: 15px;
      color: red;
      text-align: center;
      padding-top: 20px;
    }
    .forgot-pass{
      width: 100%;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #7F7F7F;
      text-align: right;
      cursor: pointer;
      padding-top: 15px;
    }
  }
}
</style>

